type PropsType = {
  styles?: object;
  stroke?: string;
  fill?: string;
};

const AreaIcon = ({ styles, stroke, fill }: PropsType) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="25"
      viewBox="0 0 23 25"
      fill="none"
    >
      <path
        d="M4.91699 4.91211H18.25C18.7488 4.91211 19.1742 5.09634 19.5312 5.46875C19.8885 5.84151 20.0664 6.28789 20.0664 6.8125V18.8125C20.0664 19.3371 19.8885 19.7835 19.5312 20.1562C19.1742 20.5287 18.7488 20.7129 18.25 20.7129H4.91699C4.41805 20.7129 3.99187 20.5289 3.63477 20.1562C3.27753 19.7835 3.09961 19.3371 3.09961 18.8125V6.8125C3.09961 6.28789 3.27753 5.84151 3.63477 5.46875C3.99187 5.09612 4.41805 4.91211 4.91699 4.91211ZM4.81641 18.9121H18.3496V6.71289H4.81641V18.9121ZM17.1914 12.9121V17.7129H12.5996V15.9121H15.4746V12.9121H17.1914ZM10.5664 7.91211V9.71289H7.69141V12.7129H5.97461V7.91211H10.5664Z"
        fill="#5B6573"
        stroke="white"
        stroke-width="0.2"
      />
    </svg>
  );
};
export default AreaIcon;
